module.exports = __webpack_public_path__ + "static/img/more_heard3.a43f4640.png";